import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import LevelBadge from "@/components/LevelBadge";

const JOURNEY = ["pawn", "knight", "bishop", "rook", "queen", "king"];
const NAMES = { pawn: "Peão", knight: "Cavalo", bishop: "Bispo", rook: "Torre", queen: "Dama", king: "Rei" };

export default function Journey() {
  const [levels, setLevels] = useState([]);
  const [courses, setCourses] = useState([]);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    api.get("/levels").then(({ data }) => setLevels(data)).catch(() => {});
    api.get("/courses").then(({ data }) => setCourses(data)).catch(() => {});
    api.get("/me/progress").then(({ data }) => setProgress(data)).catch(() => {});
  }, []);

  const currentIdx = JOURNEY.indexOf(progress?.level_key || "pawn");

  return (
    <div className="p-5 sm:p-8 max-w-4xl mx-auto">
      <h1 className="font-heading text-3xl text-chessup-text mb-2">Minha Jornada</h1>
      <p className="text-chessup-subtext text-sm mb-8">Avance nível a nível, do Peão ao Rei.</p>

      <div className="space-y-4">
        {levels.map((lv, i) => {
          const state = i < currentIdx ? "concluido" : i === currentIdx ? "atual" : "bloqueado";
          const course = courses.find((c) => c.level_key === lv.key);
          return (
            <div key={lv.key} className={`rounded-xl border p-5 flex items-center gap-5 ${state === "atual" ? "border-chessup-turq/40 bg-chessup-turq/6" : "border-chessup-border bg-chessup-card"}`}>
              <LevelBadge levelKey={lv.key} state={state} size={64} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h2 className="font-heading text-xl text-chessup-text">Nível {lv.name}</h2>
                  <span className="text-xs text-chessup-subtext">· {lv.label}</span>
                  {state === "atual" && <span className="text-xs rounded-full bg-chessup-turq/15 text-chessup-turq px-2 py-0.5">Atual</span>}
                  {state === "concluido" && <span className="text-xs rounded-full bg-chessup-gold/15 text-chessup-goldlight px-2 py-0.5">Concluído</span>}
                </div>
                <p className="text-sm text-chessup-subtext mt-1 line-clamp-2">{lv.description}</p>
              </div>
              {course && <Link to={`/cursos/${course.id}`} className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-chessup-gold px-4 py-2 text-sm font-semibold text-chessup-deep hover:bg-chessup-goldlight">Estudar <ArrowRight className="h-4 w-4" /></Link>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
